'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$$anon$176() {
  this.cdL = null;
  this.cdJ = null;
  this.cdK = false;
  this.cdH = null;
  this.cdI = false;
  this.cdM = false;
  this.cdN = false;
  this.cdL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$proto$$anon$176 as $c_Lpresto_types$proto$$anon$176 };
$p = $c_Lpresto_types$proto$$anon$176.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$$anon$176;
/** @constructor */
function $h_Lpresto_types$proto$$anon$176() {
}
export { $h_Lpresto_types$proto$$anon$176 as $h_Lpresto_types$proto$$anon$176 };
$h_Lpresto_types$proto$$anon$176.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.cdL;
});
$p.t = (function() {
  if ((!this.cdK)) {
    this.cdJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("username", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("password", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.cdK = true;
  }
  return this.cdJ;
});
$p.ae = (function() {
  if ((!this.cdI)) {
    this.cdH = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.cdI = true;
  }
  return this.cdH;
});
$p.w = (function() {
  if ((!this.cdN)) {
    this.cdM = false;
    this.cdN = true;
  }
  return this.cdM;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_types$proto$$anon$176 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$$anon$176, "presto.types$proto$$anon$176", ({
  a2K: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$proto$$anon$176 as $d_Lpresto_types$proto$$anon$176 };
//# sourceMappingURL=presto.types$proto$$anon$176.js.map
